export default {
  title: 'Subscriptions',

  table: {
    header: {
      row: 'Row',
      app: 'App',
      expiredAt: 'Expired Date',
      activeAt: 'Active Date',
      price: 'Price',
      status: 'Status',
      renewable: 'Renewable'
    }
  },

  labels: {
    priceDifference: 'Should pay'
  },

  statusTypes: {
    active: 'Active',
    pending: 'Pending',
    expired: 'Expired',
    canceled: 'Canceled'
  },

  notifications: {
    planDisabled: 'Plan is not active',
    planRenewableDisabled: 'Plan renewable is not active',
    appDisabled: 'App is not active',
    renewableActive: 'Subscription renewable is active',
    addonRenewableActive: 'Subscription addon renewable is active',
    addonDisabled: 'Addon is not active',
    incorrectAppStatus: 'App status is not valid',
    notActive: 'Subscription is not active',
    appExpirySoon: 'App expired soon',
    noChange: 'Subscription not changed',
    incorrectType: 'Subscription type is not valid',
    incorrectStatus: 'Subscription status is not valid',
    cantAddAddon: 'Addon cant be added',

    insert: {
      success: 'App subscription created successfully',
      error: 'Create app subscription has error'
    },
    edit: {
      success: 'App subscription updated successfully',
      error: 'Update app subscription has error'
    },
    delete: {
      success: 'App subscription removed successfully',
      error: 'Delete app subscription has error'
    },
    reactive: {
      success: 'App subscription reactive successfully',
      error: 'Reactive app subscription has error'
    },
    cancel: {
      success: 'App subscription canceled successfully',
      error: 'Cancel app subscription has error'
    },
    deleteAddon: {
      success: 'Addon subscription removed successfully',
      error: 'Delete addon subscription has error'
    },
    renew: {
      success: 'App subscription renew successfully',
      error: 'Renew app subscription has error'
    },
    renewAddon: {
      success: 'Addon subscription renew successfully',
      error: 'Renew addon subscription has error'
    }
  },

  confirmations: {
    delete: {
      title: 'Delete app subscription confirmation',
      body: 'Are you sure about delete app subscription?'
    },
    reactive: {
      title: 'Reactive app subscription confirmation',
      body: 'Are you sure about reactive app subscription?'
    },
    cancel: {
      title: 'Cancel app subscription confirmation',
      body: 'This subscription is accessible until the {expiredDate} and will not be added to the app upon renewal, Are you sure about cancel subscription?',
      refundPriceBody: '{price} refund to your wallet, if you cancel subscription will remove right now, Are you sure about cancel subscription?'
    },
    deleteAddon: {
      title: 'Cancel addon subscription confirmation',
      body: 'This addon is accessible until the {expiredDate} and will not be added to the app upon renewal, Are you sure about cancel addon subscription?',
      refundPriceBody: '{price} refund to your wallet, if you cancel addon will remove right now, Are you sure about cancel addon subscription?'
    },
    renew: {
      title: 'Renew app subscription confirmation',
      body: 'Are you sure about renew subscription?'
    },
    renewAddon: {
      title: 'Renew addon subscription confirmation',
      body: 'Are you sure about renew addon subscription?'
    }
  },

  confirmChanges: {
    labels: {
      addedAddons: 'New',
      removedAddons: 'Old',
      refund: 'Refund',
      finalPrice: 'Final',
      difference: 'Difference'
    },

    upgrade: {
      title: 'Upgrading will enable some features'
    },
    downgrade: {
      title: 'Downgrading will disable some features'
    },
    descriptions: {
      hasCredit: 'Since your current subscription has a credit of {credit}, a payment of {difference} is required to activate the new subscription.',
      noCredit: 'To activate the changes, please make a payment of {difference}.',
      notNeedPay: 'Since your current subscription has a credit of {difference}, no payment is required to activate the subscription.'
    }
  },

  list: {
    title: 'Subscriptions'
  },

  insert: {
    title: 'Create Subscription'
  },

  edit: {
    title: 'Edit Subscription'
  },

  subscription: {
    title: 'App subscription',

    labels: {
      planPreName: 'Plan',
      addonPreName: 'Addon'
    },

    table: {
      header: {
        row: 'Row',
        type: 'Type',
        name: 'Plan / Addon',
        title: 'Title',
        expiredAt: 'Expire Date',
        renewStatus: 'Renew Status',
        price: 'Pricing',
        action: 'Action',
        delete: 'Delete'
      }
    },

    renewStatusTypes: {
      active: 'Renew on',
      disable: 'Renew off'
    }
  }
}
